// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"548":"c635d618","890":"6770c5e5"}[chunkId] + ".css";
};